//haya
import React from "react";
import { Bar } from "react-chartjs-2";

class ChartsPage extends React.Component {
  state = {
    dataBar: {
      labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
      datasets: [
        {
          label: "#1",
          data: [12, 39, 3, 50, 2, 32, 84],
          backgroundColor: "rgba(245, 74, 85, 0.5)",
          borderWidth: 1
        },
        {
          label: "#2",
          data: [56, 24, 5, 16, 45, 24, 8],
          backgroundColor: "rgba(90, 173, 246, 0.5)",
          borderWidth: 1
        },
        {
          label: "#3",
          data: [12, 25, 54, 3, 15, 44, 3],
          backgroundColor: "rgba(245, 192, 50, 0.5)",
          borderWidth: 1
        }
      ]
    },
    barChartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [
            {
              barPercentage: 1,
              gridLines: {
                display: true,
                color: "rgba(0, 0, 0, 0.1)"
              }
            }
          ],
        yAxes: [
          {
            gridLines: {
              display: true,
              color: "rgba(0, 0, 0, 0.1)"
            },
            ticks: {
              beginAtZero: true
            }
          }
        ]
      }
    }
  }


render() {
    return (

 <div>
 <Bar data={this.state.dataBar} options={this.state.barChartOptions} />
</div>



    );
  }
}

export default ChartsPage;
